import { render, staticRenderFns } from "./ItemsCreate.vue?vue&type=template&id=ebed7d52&"
import script from "./ItemsCreate.vue?vue&type=script&lang=js&"
export * from "./ItemsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports